import React, { useEffect, useCallback, useState} from 'react';
import {setSelectedZObject} from 'actions/index.js';
import {connect} from 'react-redux';

const ZToggleComponent = ({setSelectedZObject, uxLocked, toggle, _value, height}) => { 
    let [value, setValue] = useState(_value);

    useEffect(() => {
        setValue(_value);
    }, [_value]);
    
    let className = "ztoggle ";
    if (value) {
        className += " toggled";
    }

    const onClick = useCallback(() => {
        setSelectedZObject(toggle.zObject);
        if (uxLocked) {
            setValue(toggle.toggle());
        }
    }, [toggle, setValue, uxLocked]);

    return (
        <div onClick={onClick} className={className}>
        <div 
          className="inner-x">
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      uxLocked: state.zobject.uxLocked,
      width: props.toggle.zObject.width,
      height: props.toggle.zObject.height,
      _value: props.toggle.value
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZToggleComponent);
